module.exports = __webpack_public_path__ + "img/rocketship.a0e01168.webp";